<template>
  <div class="director-home" v-loading="loading">
    <div class="yn-biz-header">
      <span class="yn-biz-title">综合部工作台</span>
      <span class="text-muted">姚洁 · 委托审核 / 派遣 / 样品交接</span>
    </div>

    <el-row :gutter="16" class="stat-row">
      <el-col :span="6">
        <el-card shadow="hover" class="stat-card" @click.native="goTodo()">
          <div class="stat-num">{{ summary.todoCount || 0 }}</div>
          <div class="stat-label">待办总数</div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card shadow="hover" class="stat-card" @click.native="goTodo('委托审核')">
          <div class="stat-num text-warn">{{ summary.entrustAudit || 0 }}</div>
          <div class="stat-label">委托审核</div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card shadow="hover" class="stat-card" @click.native="goHandover()">
          <div class="stat-num text-primary">{{ summary.handover || 0 }}</div>
          <div class="stat-label">样品管理</div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card shadow="hover" class="stat-card" @click.native="goTodo()">
          <div class="stat-num">{{ (summary.dispatchProjects || []).length }}</div>
          <div class="stat-label">派遣中项目</div>
        </el-card>
      </el-col>
    </el-row>

    <el-row :gutter="16">
      <el-col :span="12">
        <el-card shadow="never">
          <div slot="header">待接样项目 <span class="text-muted">056</span></div>
          <div v-if="!(summary.handoverItems || []).length" class="text-muted empty-tip">暂无待接样</div>
          <div
            v-for="row in summary.handoverItems || []"
            :key="row.id"
            class="list-row"
            @click="openRow(row)"
          >
            <span>{{ row.caseName }}</span>
            <span class="text-muted">{{ row.relatedForms || '056 样品交接' }}</span>
          </div>
        </el-card>
      </el-col>
      <el-col :span="12">
        <el-card shadow="never">
          <div slot="header">派遣一览 <span class="text-muted">135</span></div>
          <div v-if="!(summary.dispatchProjects || []).length" class="text-muted empty-tip">暂无派遣中项目</div>
          <div
            v-for="row in (summary.dispatchProjects || []).slice(0, 8)"
            :key="row.id"
            class="list-row"
            @click="openProject(row)"
          >
            <span>{{ row.caseName }}</span>
            <span class="text-muted">{{ row.nodeName }}</span>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <div class="quick-bar">
      <el-button type="primary" size="small" @click="$router.push('/entrust/new')">新建委托</el-button>
      <el-button type="primary" plain size="small" @click="$router.push('/task-track')">任务监控（查项目表单）</el-button>
      <el-button size="small" @click="goTodo()">待办箱</el-button>
      <el-button size="small" @click="goHandover()">样品管理</el-button>
    </div>
  </div>
</template>

<script>
import api from '@/utils/api'
import { subscribeTodoSync } from '@/utils/todoSync'

export default {
  name: 'OfficeDirectorHome',
  data() {
    return {
      loading: false,
      summary: {}
    }
  },
  mounted() {
    this.load()
    this.startAutoRefresh()
  },
  activated() {
    this.load()
    this.startAutoRefresh()
  },
  deactivated() {
    this.stopAutoRefresh()
  },
  beforeDestroy() {
    this.stopAutoRefresh()
  },
  methods: {
    startAutoRefresh() {
      this.stopAutoRefresh()
      this._unsubTodo = subscribeTodoSync(() => this.load(true))
    },
    stopAutoRefresh() {
      if (typeof this._unsubTodo === 'function') {
        this._unsubTodo()
        this._unsubTodo = null
      }
    },
    async load(silent) {
      if (!silent) this.loading = true
      try {
        const res = await api.get('yn_director_home')
        this.summary = res.data || {}
      } catch (e) {
        if (!silent) this.$message.error('加载工作台失败')
      } finally {
        if (!silent) this.loading = false
      }
    },
    goTodo(filter) {
      const q = filter ? { filter } : {}
      this.$router.push({ path: '/todo', query: q }).catch(() => {})
    },
    goHandover() {
      this.$router.push('/soil/handover').catch(() => {})
    },
    openRow(row) {
      if (!row || !row.route) return
      this.navigate(row.route)
    },
    openProject(row) {
      if (row && row.xmbh) {
        this.$router.push({ path: '/task-track', query: { xmbh: row.xmbh } }).catch(() => {})
        return
      }
      this.openRow(row)
    },
    navigate(r) {
      const qi = r.indexOf('?')
      if (qi >= 0) {
        const path = r.slice(0, qi)
        const query = {}
        r.slice(qi + 1).split('&').forEach(pair => {
          const eq = pair.indexOf('=')
          if (eq < 0) return
          query[pair.slice(0, eq)] = decodeURIComponent(pair.slice(eq + 1))
        })
        this.$router.push({ path, query }).catch(() => {})
      } else {
        this.$router.push(r).catch(() => {})
      }
    }
  }
}
</script>

<style scoped>
.director-home { padding: 0 4px; }
.stat-row { margin: 16px 0; }
.stat-card { cursor: pointer; text-align: center; }
.stat-num { font-size: 28px; font-weight: 700; }
.stat-label { color: #909399; margin-top: 6px; }
.text-warn { color: #e6a23c; }
.text-primary { color: #409eff; }
.text-muted { color: #909399; font-size: 12px; }
.list-row {
  display: flex;
  justify-content: space-between;
  padding: 10px 0;
  border-bottom: 1px solid #ebeef5;
  cursor: pointer;
}
.list-row:hover { color: #409eff; }
.empty-tip { padding: 24px 0; text-align: center; }
.quick-bar { margin-top: 16px; }
</style>
